import { useEffect } from 'react'

export default function Toast({ type, message, title, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000)
    return () => clearTimeout(timer)
  }, [onClose])

  const baseClasses = 'flex items-start gap-3 px-4 py-3 rounded-lg shadow-lg animate-fade-in'
  const typeClasses = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    info: 'bg-blue-500 text-white',
    warning: 'bg-yellow-500 text-white',
  }

  const iconClasses = {
    success: 'fa-check-circle',
    error: 'fa-exclamation-circle',
    info: 'fa-info-circle',
    warning: 'fa-exclamation-triangle',
  }

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      <i className={`fas ${iconClasses[type]} flex-shrink-0 mt-0.5`}></i>
      <div className="flex-1">
        {title && <div className="font-semibold">{title}</div>}
        <div className="text-sm">{message}</div>
      </div>
      <button
        onClick={onClose}
        className="ml-2 text-lg hover:opacity-70 transition-opacity"
      >
        ×
      </button>
    </div>
  )
}
